import {Button, closeCurrentDialog, DataStatus, openDialog, Tag} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import {useGetQuickPresetsQuery} from '@dms/api/settings';
import i18n from '@dms/i18n';

import {CreateQuickPresetDialog} from './CreateQuickPresetDialog';

interface AddQuickPresetDialogProps {
  selectedPresets: {id: string; name: string}[];
  onSelect: (value: {id: string; name: string}) => void;
}

export function AddQuickPresetDialog(props: AddQuickPresetDialogProps) {
  const quickPresetsQuery = useGetQuickPresetsQuery();
  const selectedPresetIds = props.selectedPresets.map((p) => p.id);

  return (
    <DataStatus isLoading={quickPresetsQuery.isLoading} isError={quickPresetsQuery.isError}>
      <VStack spacing={2}>
        <HStack spacing={1} align="center" wrap>
          {quickPresetsQuery?.data
            ?.filter((preset) => !selectedPresetIds.includes(preset.id))
            .map((preset) => (
              <Tag
                key={preset.id}
                onClick={() => {
                  props.onSelect(preset);
                  closeCurrentDialog();
                }}
                label={preset.name}
                colorScheme="purple"
              />
            ))}
        </HStack>
        <Box>
          <Button
            variant="link"
            leftIcon="content/add_circle"
            onClick={() =>
              openDialog(
                <CreateQuickPresetDialog
                  onSubmit={(value) => {
                    props.onSelect(value);
                    closeCurrentDialog();
                  }}
                />,
                {
                  title: i18n.t('page.settings.labels.advertisingQuickPresets.create'),
                  size: 'small',
                }
              )
            }
            title={i18n.t('page.settings.labels.advertisingQuickPresets.create')}
          />
        </Box>
      </VStack>
    </DataStatus>
  );
}
